export const CSV_CONTENT_TYPE = "text/csv";

type BuildExportCSVTextProps = {
  /** Header row followed by data rows */
  data: unknown[][];
};

/**
 * Writes one sheet as CSV. Strings containing a quote, comma or line break are
 * quoted, with inner quotes doubled.
 */
export const buildExportCSVText = ({ data }: BuildExportCSVTextProps): string =>
  data
    .map((row) =>
      row
        .map((col) => {
          if (typeof col === "string" && /[",\n\r]/.test(col)) {
            // eslint-disable-next-line quotes
            return `"${col.replace(/"/g, '""')}"`;
          }
          return col;
        })
        .join(","),
    )
    .join("\n");
